export function formatBRL(cents: number): string {
  return new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(cents / 100);
}

export function formatDateTimeSaoPaulo(iso: string): string {
  return new Intl.DateTimeFormat("pt-BR", { dateStyle: "short", timeStyle: "short", timeZone: "America/Sao_Paulo" }).format(new Date(iso));
}

export function formatDateSaoPaulo(iso: string): string {
  return new Intl.DateTimeFormat("pt-BR", { dateStyle: "short", timeZone: "America/Sao_Paulo" }).format(new Date(iso));
}

/**
 * Converte valor em centavos para a máscara monetária brasileira no formato "X.XXX,XX".
 * Inicia com centavos (ex: 5 -> "0,05", 50 -> "0,50", 500 -> "5,00", 125000 -> "1.250,00").
 */
export function centsToCurrencyMask(cents: number | null | undefined, allowEmpty = false): string {
  if (cents == null || isNaN(cents)) {
    return allowEmpty ? "" : "0,00";
  }
  if (cents === 0 && allowEmpty) {
    return "";
  }
  const absCents = Math.abs(Math.round(cents));
  const padded = String(absCents).padStart(3, "0");
  const integerPart = padded.slice(0, -2);
  const decimalPart = padded.slice(-2);
  const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  return `${formattedInteger},${decimalPart}`;
}

/**
 * Extrai todos os dígitos de uma string mascarada e retorna o valor inteiro correspondente em centavos.
 */
export function parseCurrencyMaskToCents(maskedValue: string): number {
  if (!maskedValue) return 0;
  const digits = maskedValue.replace(/\D/g, "");
  if (!digits) return 0;
  return parseInt(digits, 10) || 0;
}

/**
 * Aplica a máscara reversa ATM ao digitar:
 * Os dígitos entram pela direita (centavos) e deslocam os demais para a esquerda (X.XXX,XX).
 */
export function applyCurrencyMask(rawInput: string, allowEmpty = false): string {
  const digits = rawInput.replace(/\D/g, "");
  if (!digits) {
    return allowEmpty ? "" : "0,00";
  }
  const cents = parseInt(digits, 10) || 0;
  return centsToCurrencyMask(cents, allowEmpty);
}
